import axiosCall from "../../axiosCall";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import base64 from "base-64";
import { BASE_URL, PARTNER_AK_VALUE, CPR_AK_VALUE, FAF_AK_VALUE, CASE_AK_VALUE, systemData, PARTNER_BROWSER_ID } from '../../../constant/Constants'
import forge from "node-forge";

export const generateBrowserID = () => {
    //Generating Browser Token
    let arrBToken = [uuidv4(), Math.floor(Math.random() * 1000000 + 1)];
    let bToken = arrBToken.join("");

    let md = forge.md.md5.create();
    md.update(bToken);
    let md5BToken = md.digest().toHex();
    const browserID = md5BToken;
    PARTNER_BROWSER_ID.ID=browserID
    return browserID
}

// PreAuth API
export const fetchPreAuth = async (callback = () => { }) => {
    let session = await axios.get("https://api.ipify.org?format=json");
    let SessionManagement = {
        Location: ``,
        UserAgent: navigator.userAgent,
        IP: session?.data?.ip,
    };

    systemData.userAgent = SessionManagement.UserAgent;
    systemData.ipAddress = SessionManagement.IP;
    const browserToken = generateBrowserID();
    const response = await axiosCall('post', `/NoAuth/v1/PreAuthentication/3?`, null, `BrowserID=${browserToken}`, SessionManagement, 'PARTNER', true);
    let getPattern = response.data.SessionManagement?.SessionToken?.split("-")
    if (getPattern) {
        let firset = getPattern[6].split("");
        let secondSet = getPattern[7].split("");
        let thirdSet = getPattern[8].split("");
        let pattern = getPattern[firset[0]] + getPattern[firset[1]] + "-" + getPattern[secondSet[0]] + "-" + getPattern[secondSet[1]].substr(0, 2);
        // let basicAuth = ("Basic " +
        //     base64.encode(
        //         "PPPAPI" +
        //         ":" +
        //         getPattern[thirdSet[0]] +
        //         getPattern[thirdSet[1]]
        //     ))
        // state.headers.Authorization = basicAuth;
        // callback(browserToken, basicAuth)
    }
    //callback(browserToken)
    return { resData: response.data, browserToken, IP: session?.data?.ip, }
}



export const fetchPreAuthCPR = async (data) => {

    const browserToken = generateBrowserID();
    let session = await axios.get("https://api.ipify.org?format=json");
    let SessionManagement = {
        Location: ``,
        UserAgent: navigator.userAgent,
        IP: session?.data?.ip,
    };

    systemData.userAgent = SessionManagement.UserAgent;
    systemData.ipAddress = SessionManagement.IP;
    const response = await axiosCall('post', `/NoAuth/v1/PreAuthentication/${data.PROGRAM_ID}?`, null, `BrowserID=${browserToken}`, SessionManagement, data.PROGRAM, true);


    return { resData: response.data, browserToken }
}


export const fetchPreAuthFAF = async (data) => {

    const browserToken = generateBrowserID();
    let session = await axios.get("https://api.ipify.org?format=json");
    let SessionManagement = {
        Location: ``,
        UserAgent: navigator.userAgent,
        IP: session?.data?.ip,
    };
    const response = await axiosCall('post', `/NoAuth/v1/PreAuthentication/${data.PROGRAM_ID}?`, null, `BrowserID=${browserToken}`, SessionManagement, data.PROGRAM, true);
    //callback(browserToken)
    return { resData: response.data, browserToken }
}